<template>
  <tr>
    <td :class="campaignColumnStyles">
      <v-btn @click="$emit('toggleCampaign')" icon flat small class="ma-0">
        <v-icon :class="iconStyles">keyboard_arrow_right</v-icon>
      </v-btn>
    </td>
    <td :class="columnStyles" style="text-align: left;">
      {{ data.name }} ({{ data.id }})
    </td>
    <td :class="columnStyles">
      <ChangeBPDialog
        v-model="selectedBpIds"
        :data="data"
        :style="{ cursor: 'pointer' }"
      />
    </td>
    <td v-if="!isHideRevenue" :class="columnStyles">
      <AppCurrency :value="data.insertionOrderBudget" />
    </td>
    <td v-if="!isHideRevenue" :class="columnStyles">
      <AppCurrency :value="data.revenueBuyingCurrency" />
    </td>
    <td :class="columnStyles">
      <AppNumberWithUnit :value="data.imps" local-string />
    </td>
    <td :class="columnStyles">
      <AppNumberWithUnit :value="data.clicks" local-string />
    </td>
    <td :class="columnStyles"><AppCtr :value="data.ctr" /></td>
    <td v-if="!isHideRevenue" :class="columnStyles">
      <AppCurrency :value="data.cpc" />
    </td>
    <td v-if="!isHideRevenue" :class="columnStyles">
      <AppCurrency :value="data.cpm" />
    </td>
    <td v-if="!isHideRevenue" :class="columnStyles">
      <AppVideoCompletion :value="data.videoCompletions" local-string />
    </td>
  </tr>
</template>

<script>
import { css } from 'emotion'
import baseColorRepository, {
  name,
} from '@/middlewares/styles/baseColorRepository'
import ChangeBPDialog from './ChangeBPDialog'
import { mapActions } from 'vuex'

export default {
  name: 'MainTableRow',
  components: { ChangeBPDialog },
  props: {
    data: {
      type: Object,
      required: true,
    },
    selectedBillingPeriodIds: {
      type: Array,
      default: () => [],
    },
    fetchedColor: {
      type: Object,
      default: () => ({}),
    },
    isHideRevenue: {
      type: Boolean,
      default: false,
    },
    openCampaign: Boolean,
  },
  data() {
    return {
      showBpSelector: false,
    }
  },
  computed: {
    selectedBpIds: {
      get() {
        return this.selectedBillingPeriodIds == null
          ? []
          : [...this.selectedBillingPeriodIds]
      },
      set(value) {
        this.selectBillingPeriods({
          insertionOrderId: this.data.id,
          billingPeriodIds: value,
        })
      },
    },
    columnStyles() {
      const color = baseColorRepository(this.fetchedColor)
      return [
        'io__column',
        css`
          background: ${color[name.base2]};
        `,
      ]
    },
    campaignColumnStyles() {
      return [...this.columnStyles, 'io__column--center']
    },
    iconStyles() {
      return ['io__arrow-icon', { 'io__arrow-icon__turn': this.openCampaign }]
    },
  },
  methods: {
    ...mapActions('advertiser/standardReport', {
      selectBillingPeriods: 'SELECT_BILLING_PERIODS',
    }),
  },
}
</script>

<style scoped lang="scss">
.io {
  &__column {
    text-align: right;
    padding: 5px 10px;
    border-top-width: 1px;
    border-top-style: solid;
    border-top-color: #ffffff;
    font-weight: normal;
    white-space: nowrap;

    &--clickable {
      cursor: pointer;
    }

    &--center {
      text-align: center;
    }
  }

  &__arrow-icon {
    vertical-align: middle;

    &__turn {
      transform: rotate(90deg);
    }
  }
}
</style>
